import { render } from "./Aiservice.vue?vue&type=template&id=452aedb9&scoped=true"
const script = {}

import "./Aiservice.vue?vue&type=style&index=0&id=452aedb9&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452aedb9"]])

export default __exports__